import { liveQuery } from 'dexie';
import { useEffect, useState } from 'react';

/**
 * Мінімальний міст між Dexie liveQuery і React.
 * Тримаємо свій, щоб не тягнути ще одну залежність: потреба тут одна —
 * перемальовувати індикатор черги, коли в IndexedDB щось змінилося.
 */
export function useLiveQuery<T>(querier: () => Promise<T>, deps: readonly unknown[], initial: T): T {
  const [value, setValue] = useState<T>(initial);

  useEffect(() => {
    const subscription = liveQuery(querier).subscribe({
      next: (next) => setValue(next as T),
      error: (error: unknown) => {
        // Мовчки ковтати не можна: якщо локальна база зламалась, це серйозно.
        console.error('[offline] liveQuery впав', error);
      },
    });
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return value;
}
